import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import styled from "styled-components";
import type { FC } from "react";

const CIRCLE_CLASS = "circle-loader";
const CIRCLE_DIAMETER = {
    SMALL: "30px",
    MEDIUM: "50px",
    BIG: "80px",
};
const AXIS_WIDTH = 5;

const Container = styled.div`
    opacity: 0.8;
    padding: 0px 32px;
    width: calc(100% - 48px);
    height: 465px;
    position: relative;
    .${CIRCLE_CLASS} {
        border-radius: 50%;
    }
`;

const AbsoluteCircleContainer = styled.div<{ left: string; bottom: string }>`
    position: absolute;
    ${({ left, bottom }) => `
        left: ${left};
        bottom: ${bottom};
    `}
`;

const AbsoluteCircle: FC<{ diameter: string; left: string; bottom: string }> = (props) => {
    const { diameter, bottom, left } = props;
    return (
        <AbsoluteCircleContainer
            left={left}
            bottom={bottom}
        >
            <PixelPlaceholderLoader
                width={diameter}
                height={diameter}
                className={CIRCLE_CLASS}
            />
        </AbsoluteCircleContainer>
    );
};

const YaxisContainer = styled.div`
    position: relative;
    bottom: -48px;
    height: 100%;
`;
const Yaxis = () => {
    return (
        <YaxisContainer>
            <PixelPlaceholderLoader
                width={AXIS_WIDTH}
                height={"95%"}
            />
        </YaxisContainer>
    );
};
export const BubbleChartLoaderSkeleton = () => {
    return (
        <Container>
            <Yaxis />
            <PixelPlaceholderLoader
                width={"100%"}
                height={AXIS_WIDTH}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.BIG}
                left={"40%"}
                bottom={"200px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.BIG}
                left={"50%"}
                bottom={"90px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.BIG}
                left={"60%"}
                bottom={"180px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.BIG}
                left={"80%"}
                bottom={"70px"}
            />

            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.MEDIUM}
                left={"5%"}
                bottom={"30px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.MEDIUM}
                left={"25%"}
                bottom={"180px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.MEDIUM}
                left={"35%"}
                bottom={"100px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.MEDIUM}
                left={"50%"}
                bottom={"260px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.MEDIUM}
                left={"70%"}
                bottom={"120px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.MEDIUM}
                left={"90%"}
                bottom={"200px"}
            />

            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.SMALL}
                left={"10%"}
                bottom={"280px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.SMALL}
                left={"20%"}
                bottom={"180px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.SMALL}
                left={"30%"}
                bottom={"80px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.SMALL}
                left={"40%"}
                bottom={"80px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.SMALL}
                left={"50%"}
                bottom={"50px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.SMALL}
                left={"60%"}
                bottom={"60px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER.SMALL}
                left={"80%"}
                bottom={"190px"}
            />
        </Container>
    );
};
